/* eslint-disable react-hooks/rules-of-hooks */
import { ColumnDef } from '@tanstack/table-core';
import DropdownSubHeader from './dropdown-subHeader';
import SelectInputBox from '../../../../pricing-simulator/components/table-columns/select-input-box';
import {
  Header,
  TableComponent,
  InputType
} from '../../../../pricing-simulator/types/generic-table.model';
import { IMPLEMENTATION_PERIOD_1_KEY } from 'src/constants';
import { createMappingKPI1 } from '../columns-prep';

export default function generateColumnForImplementPeriod2Dropdown(
  columnData: Header,
  columnMetadata: Header[],
  pricingAction1Value: any,
  componentType?: TableComponent,
  maxVal?: number,
  inputsDisabled?: boolean
) {
  let sortedDropdownData = [...columnData.parent.static_values];

  const filteredSet2Options = sortedDropdownData
    .filter((option) => option.value > pricingAction1Value)
    .sort((a, b) => (a.value > b.value ? 1 : -1));

  // Get all KPI 1 column fields for header
  const kpi1Fields = createMappingKPI1(columnMetadata);

  const subHeader: ColumnDef<{ [key: string]: number | string }> = {
    accessorKey: columnData.parent.parent_field,
    header: () => (
      <DropdownSubHeader
        columnData={columnData}
        inputsDisabled={inputsDisabled}
        pricingAction1Value={pricingAction1Value}
        filteredSet2Options={filteredSet2Options}
        kpi1Fields={kpi1Fields}
      />
    ),
    cell: ({ row }) => {
      const implementPeriod1 = row?.original?.[IMPLEMENTATION_PERIOD_1_KEY];
      const filteredCellOptions = sortedDropdownData
        .filter((option) => option.value > implementPeriod1)
        .sort((a, b) => (a.value > b.value ? 1 : -1));

      // Check if at least ONE KPI 1 field has a valid value
      const hasAnyKPI1Value = kpi1Fields.some((field) => {
        const value = row?.original?.[field];
        return (
          value !== null &&
          value !== undefined &&
          value !== 0 &&
          value !== '-' &&
          value !== ''
        );
      });

      // Disable if no KPI 1 values are present
      const isDisabled = inputsDisabled || !hasAnyKPI1Value;

      const idColumns: Header[] = columnMetadata
        .filter(
          (data) =>
            !data.parent.is_visible &&
            data.parent.field_format === InputType.NUMBER
        )
        .sort((a, b) => a.parent.level - b.parent.level);

      return (
        <SelectInputBox
          row={row}
          uniqueIDColumns={idColumns}
          inputsDisabled={isDisabled}
          columnMetadata={columnData}
          filteredOptions={filteredCellOptions ? filteredCellOptions : []}
        />
      );
    },
    meta: {
      className:
        columnData.parent.order === maxVal || maxVal === undefined
          ? 'last'
          : '',
      style: { minWidth: '125px', textAlign: 'center' }
    }
  };

  return subHeader;
}
